<template>
  <div class="site__centered">

    <div class="application form">
      <h2 class="application__title capitalize">{{ camperStudent('plural') }} </h2>
      <div
        v-if="childrenList.length > 0"
      >
        <ChildItem 
          v-for="(child, index) in childrenList"
          :key="index"
          :child="child"
          :disabled="true"
        />
        <button
          class="btn btn--color-dark form__button capitalize"
          @click="addNewChild"
        >Add A {{ camperStudent('singular') }}</button>
      </div>
    </div>
    <AddNewChildModal 
      :is-show-modal="isShowModal"
      :default-gender="defaultGender"
      :family-name="parent.last_name"
      :family-id="parent.family_id"
      @cancel="goNext"
      @closeModal="closeModal"
      @updateChildrenList="addedChild"
    />

    <TimeToAddingChildInfoModal
      @add-new-child="addNewChild"
      @skip="goNext"
    />

    <DoYouWantToAddAnotherChildInfoModal
      @add-new-child="addNewChild"
      @stop-adding="goNext"
    />

  </div>
</template>

<script>

  import { scrollToTop } from '@/helpers/scrollToTop'
  import ChildItem from '@/views/Children/ChildItem.vue'
  import AddNewChildModal from '@/components/site/add-new-child-modal/AddNewChildModal.vue'
  import store from '@/store'
  import { getHomeRouteForLoggedInUser, getUserData } from '@/auth/utils'
  import { prepareProgramRegistrationInfo } from '@core/mixins/prepareProgramRegistrationInfo'
  import { mapGetters } from 'vuex'
  import TimeToAddingChildInfoModal from '@/components/site/add-new-child-modal/TimeToAddingChildInfoModal.vue'
  import DoYouWantToAddAnotherChildInfoModal
    from '@/components/site/add-new-child-modal/DoYouWantToAddAnotherChildInfoModal.vue'
  import { instanceSessionCamperNames } from '@core/mixins/instanceSessionCamperNames'

  export default {
    name: 'AddingNewChild',
    components: {
      DoYouWantToAddAnotherChildInfoModal,
      TimeToAddingChildInfoModal,
      ChildItem,
      AddNewChildModal,
    },
    mixins: [ prepareProgramRegistrationInfo, instanceSessionCamperNames ],
    data() {
      return {
        parent: getUserData(),
        isShowModal: false,
        defaultGender: null,
      }
    },
    computed: {
      ...mapGetters({
        authSettings: 'authSettings/getAuthSettings',
        childrenList: 'children/getChildrenList',
        returnPageRouteName: 'registration/getReturnPageRouteName',
        returnPageRouteParams: 'registration/getReturnPageRouteParams',
      }),
    },
    beforeRouteEnter(to, from, next) {
      const role = getUserData().role
      next((vm) => {
        if(role !== 'parent'){
          vm.$router.replace({ name: 'error-404' })
          return
        }
        // Hydrate return-route info from route params when present
        // (e.g. coming fresh from Register.vue redirect or after a page refresh)
        if (to.params.return) {
          store.commit('registration/SET_RETURN_PAGE_ROUTE_NAME', to.params.return)
        }
        if (to.params.routeParams) {
          store.commit('registration/SET_RETURN_PAGE_ROUTE_PARAMS', to.params.routeParams)
        }
      })
    },
    async mounted() {
      await this.prepareData()
      if (this.childrenList.length === 0) {
        this.$bvModal.show('time-adding-child-info-modal')
      }
    },
    methods: {
      async prepareData() {
        store.commit('SET_LOADING_STATUS', true)

        this.defaultGender = this.authSettings.default_gender
        await this.setChildrenList()

        store.commit('SET_LOADING_STATUS', false)
      },
      addNewChild() {
        scrollToTop()
        this.isShowModal = true
      },
      closeModal() {
        this.isShowModal = false
      },
      goNext() {
        if (this.returnPageRouteName) {
          if (this.returnPageRouteName === 'application-create') {
            this.$router.replace({ name: 'application-select-child', params: this.returnPageRouteParams})
            return
          }
          this.$router.replace({ name: this.returnPageRouteName, params: this.returnPageRouteParams})
        } else {
          this.$router.replace(getHomeRouteForLoggedInUser('parent'))
        }
      },
      addedChild() {
        this.$bvModal.show('do-you-want-to-add-another-child-info-modal')
        this.setChildrenList()
      },
      async setChildrenList() {
        this.$emit('loading', true)

        await this.$store.dispatch('children/fetchChildrenList')

        this.$emit('loading', false)
      },
    },
  }
</script>

<style scoped>
</style>